export enum RenderingContractGroupType {
  EMOBILITY = 'emobility',
  COMMODITY = '',
}
